function getProtocol(url) {
    if (!url) {
        return '';
    }
    const urlRe = /((https?)\:\/\/)?([^\?\:\/#]+)(\:([0-9]+))?(\/[^\?\#]*)?(\?([^#]*))?(#.*)?/i;
    const match = url.match(urlRe);
    return match[2] || 'http:';
}

function isExternalUrl(url) {
    return /^(?:(?:https?:)\/\/)(?:(?:[\u0400-\uA69F\w][\u0400-\uA69F\w-]*)?[\u0400-\uA69F\w]\.)+(?:[\u0400-\uA69Fa-z]+|\d{1,3})(?::[\d]{1,5})?(?:[/?#].*)?$/i.test(url);
}

function isValidProtocol(url, RGI) {
    const protocol = getProtocol(url);
    const siteUrl = RGI.getFullUrl();
    const siteProtocol = getProtocol(siteUrl);

    if(protocol === 'http' && siteProtocol === 'https') {
        return false;
    }
    return true;
}

export {
    isExternalUrl,
    isValidProtocol
};
